import React from 'react'
import Skeleton from 'react-loading-skeleton';

function PostSkeleton() {
    return (
        <div className="col-lg-4 col-md-6 mt-md-0 mt-4">
            <a href={`/posts/`}>
                <Skeleton className="top-pic1" />
            </a>
        </div>
    )
}

export default PostSkeleton
